<template>
  <div class="main">
    
    <header class="header">
      
      <img class="logoImg" :src="logoImg" />

      <div class="title">{{ title }}</div>
      <div class="registerBtn" @click="registerBtnClicked">注册</div>

      <div v-if="isLogin" class="userBox" @click="showOrHideUserMenu">{{username}}</div> 
      <div v-else class="loginBtn" @click="loginBtnClicked">登录</div> 
    </header>
    <div class="userMenu" v-if="isShowUserMenu">
      <!-- <div>设置</div> -->
      <div class="userMenuItem" @click="handleDeleteUser">注销</div>
      <div class="userMenuItem" @click="handleLogout">退出登录</div>
    </div>
    <div class="body">
       <div id="mapContainer"></div>
      
        <div class="airlineInfoBox" @click="selectNotice">
          <div class="airlineTitle">项目：</div>
          <div class="airlineName">{{selectedProject.projectName?selectedProject.projectName:'未选择'}}</div>
        </div>
        <div class="airlineInfoBox" style="top:60px" @click="selectNotice">
          <div class="airlineTitle">航线：</div>
          <div class="airlineName">{{selectedAirline?selectedAirline.airlineName:'未选择'}}</div>
        </div>

        <!-- 左侧按钮 -->
        <div style="top:160px;position: absolute ;">
        <div class="leftMenuBtn" style="top:0px" @click="showOrHideProjectAndAirline" title="文件">
          <img class="normalImg" :src="fileImg" />
        </div>
         <div class="leftMenuBtn" style="top:30px" @click="saveBtnClicked" title="保存">
          <img class="normalImg" :src="saveImg"/>
        </div>
        <div class="leftMenuBtn" style="top:60px" @click="clearBtnClicked" title="清除">
          <img class="normalImg" :src="clearImg"/>
        </div>
        <div class="leftMenuBox" style="width: auto;top:100px;display: flex;">
          <div class="leftMenuBtn" style="top:0;left:0" @click="kmlBtnClicked" title="导入KML文件">
            KML
            <!-- <img class="normalImg" :src="fileImg" /> -->
            <div>
              <input type="file" @change="changes" ref="kmlFileInput" v-show="false"/>
            </div>
            
          </div>
          <div style="color:lightcoral;margin-left: 16px;">？点击导入本地Kml</div>
        </div>
        </div>
        <project v-if="isShowProjectAndAirline" @onSelectProject="receiveSelectedProject"></project>
        <airline v-show="isShowProjectAndAirline" :selectedProjectId="selectedProject.projectId"
        @onLoadAirline="receiveLoadAirline"></airline>
        <ProjectSave v-if="isShowProjectSave" @onSelectProject="receiveSelectedProjectToSave"></ProjectSave>
        <div class="settingBox">
          <div class="settingHeader">
            <div class="settingHeaderItem" @click="showMissionSetting">任务设置</div>
            <div class="settingHeaderItem"  @click="showWaypointSetting">航点设置</div>
            <!-- <div class="settingHeaderItem"  @click="showInterestSetting">兴趣点设置</div> -->
          </div>
          
          <div class="settingContent">
            <div class="missionSettingBox" v-show="settingIndex == 0">
              <div class="missionSettingItem">
                 <div class="missionSettingItemTitle">
                   <div class="missionSettingItemTitleName">高度(m)</div>
                   <div class="missionSettingItemTitleValue">{{mAltitude}}</div>
                 </div>
                 <slider :min="0" :max="500" :value="30" 
                 @percent="missionAltitudeChanged"></slider>
              </div>
             
              <div class="missionSettingItem">
                 <div class="missionSettingItemTitle">
                   <div class="missionSettingItemTitleName">速度(m/s)</div>
                   <div class="missionSettingItemTitleValue">{{mSpeed}}</div>
                 </div>
                
                 <slider :min="0" :max="15" :value="2"
                 @percent="missionSpeedChanged"></slider>
              </div>

              <div class="settingFooter">

              </div>
            </div>

            <div class="waypointSettingBox" v-if="settingIndex == 1 && mWaypointsArr.length">
              <div class="missionSettingItem">
                <div class="missionSettingItemTitle">
                   <div class="missionSettingItemTitleName">航点</div>
                   <div class="missionSettingItemTitleValue">{{waypointIndex+1}}</div>
                 </div>
              </div>
              <div class="missionSettingItem">
                 <div class="missionSettingItemTitle">
                   <div class="missionSettingItemTitleName">经纬度</div>
                   <div class="missionSettingItemTitleValue">
                     {{mWaypointsArr[waypointIndex].position.longitude + ',' 
                     + mWaypointsArr[waypointIndex].position.latitude}}</div>
                 </div>                
              </div>

              <div class="missionSettingItem">
                 <div class="missionSettingItemTitle">
                   <div class="missionSettingItemTitleName">高度(m)</div>
                   <div class="missionSettingItemTitleValue">{{mWaypointsArr[
      waypointIndex].altitude}}</div>
                 </div>
                 <slider :min="0" :max="500" :value="mWaypointsArr[
      waypointIndex].altitude" 
                 @percent="waypointAltitudeChanged"></slider>
              </div>
             
              <div class="missionSettingItem">
                 <div class="missionSettingItemTitle">
                   <div class="missionSettingItemTitleName">速度(ms/s)</div>
                   <div class="missionSettingItemTitleValue">{{mWaypointsArr[
      waypointIndex].speed}}</div>
                 </div>
                
                 <slider :min="0" :max="15" :value="mWaypointsArr[
      waypointIndex].speed"
                 @percent="waypointSpeedChanged"></slider>
              </div>

              <div class="settingFooter" v-if="true">
                  <div class="waypointOperationBtn" @click="goToPreviousWaypoint">
                    <img class="previousImg" :src="previousImg"/>
                  </div>
                  <div class="waypointOperationBtn"
                  @click="goToNextWaypoint">
                    <img class="nextImg" :src="nextImg"/>
                  </div>
              </div>
            </div>
            <div v-if="mWaypointsArr.length === 0" style="color:rgba(255,255,255,0.6)">暂无航点</div>

            <div class="interestSettingBox" v-show="settingIndex == 2">
            
              <div class="settingFooter">

              </div>
            </div>

          </div>

          
        </div>
    </div>
    
    <register v-if="isShowRegister" @onRegisterSuccess="receiveRegisterSuccess"
    @onRegisterClose="receiveRegisterClose"></register>
    <Login v-if="isShowLogin" @onLoginSuccess="receiveLoginSuccess"
     @receiveClose="receiveClose"></Login>
    <footer class="footer">
      <a href="https://beian.miit.gov.cn/">苏ICP备2022023346号</a>
    </footer>

    <el-dialog
      v-model="dialogVisible"
      title="请输入内容"
      width="500px"
      @close="closeDialog"
    >
      <!-- 输入框 -->
      <el-form ref="formRef" :model="form" label-width="80px">
        <el-form-item
          label="输入内容"
          prop="inputText"
          :rules="[{ required: true, message: '请输入内容', trigger: 'blur' }]"
        >
          <el-input
            v-model="form.inputText"
            placeholder="请输入..."
            style="width: 300px"
          />
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmSubmit">
            确定提交
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Register from './Register.vue'
import Login from './Login.vue'
import Project from './Project.vue';
import Airline from './Airline.vue'
import Slider from '../components/slider.vue'
import togeojson from "@mapbox/togeojson";
import ProjectSave from './ProjectSave.vue';

export default {
  name: 'Main',
  data () {
    return {
      logoImg: require('../assets/images/web_icon.png'),
      previousImg:require('../assets/images/previous.png'),
      nextImg:require('../assets/images/next.png'),
      saveImg:require('../assets/images/save.png'),
      fileImg:require('../assets/images/file.png'),
      clearImg:require('../assets/images/clear.png'),
      waypointImg:require('../assets/images/waypoint.png'),
      waypointDirImg:require('../assets/images/waypoint_direction.png'),
      //Smart Flight For DJI
      title: '个人航线规划',
      map: undefined,
      mMarkerList:[],
      mWaypointsArr:[],
      mWaypointsPositionArr:[],
      waypointIndex:0,
      mAltitude:30,
      mSpeed:2,
      settingIndex:0,
      isShowRegister:false,
      isShowLogin:false,
      isLogin:false,
      isShowUserMenu:false,
      isShowProjectAndAirline:false,
      isShowProjectSave:false,
      username:'',
      selectedProject:{},
      selectedAirline:null
    }
  },
  components:{
    Register,
    Login,
    Project,
    Airline,
    ProjectSave,
    Slider
    
  },
  mounted() {
    this.getUserInfo();
    this.initMap();
   
  },
  methods: {
    registerBtnClicked() {
      this.isShowRegister = true;
    },
    loginBtnClicked(){
      this.isShowLogin = true;
    },
    showOrHideUserMenu() {
      this.isShowUserMenu = !this.isShowUserMenu;
    },
    handleLogout() {
      this.$confirm('您确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' // 警告类型（warning/success/info/error）
      }).then(() => {
        // ========== 点了【确定】执行这里 ==========
        console.log('执行删除操作')
        
        // 这里写你的接口请求
        this.logout();
        
      }).catch(() => {

      });
    },
    logout() {
      this.isLogin = false;
      this.isShowUserMenu = false;
      localStorage.setItem('token','');
      this.$message({
        message: '已退出登录'
      })
    },
    handleDeleteUser() {
      // $alertBox.alert({
      //     message:"请输入用户名"
      //   })

      this.$confirm('此操作将永久删除当前账户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' // 警告类型（warning/success/info/error）
      }).then(() => {
        // ========== 点了【确定】执行这里 ==========
        console.log('执行删除操作')
        
        // 这里写你的接口请求
        this.deleteUser();
        
        
      }).catch(() => {
        // ========== 点了【取消】执行这里 ==========
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      });

    },
    deleteUser() {
      
      let url = baseIp + 'user/deleteUser'
     
      let config = {
        headers:{
         
        "token":localStorage.getItem('token'),
        "Access-Control-Allow-Origin":'*'
        }
        
      };
      console.log(url);

      this.$ajax.post( url,null,config)
      .then((res)=>{
        console.log(res);
        console.log(res.data); 
        if (res.data.code == 200) {
          // $alertBox.alert({
          //   message:"注销成功"
          // })
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.isLogin = false;
          this.isShowUserMenu = false;
          localStorage.setItem('token','');
        }
        else {
          // $alertBox.alert({
      //     message:"请输入用户名"
      //   })
        }
      })
    },
    selectNotice() {
      if(!this.selectedProject.projectName || !this.selectedAirline.airlineName) {
        this.$message("请点击下方文件按钮进行选择");
      }
    },
    showOrHideProjectAndAirline() {
      if (!this.isLogin) {
        this.loginBtnClicked();
        return;
      }
      this.isShowProjectAndAirline = !this.isShowProjectAndAirline;
    },
    receiveRegisterClose() {
      console.log("receiveRegisterClose");
      this.isShowRegister = false;
    },
    receiveRegisterSuccess() {
      console.log("receiveRegisterSuccess");
      this.isShowRegister = false;
      this.isShowLogin = true;
    },
     receiveClose() {
      this.isShowLogin = false;
    },
    receiveLoginSuccess() {
      this.isShowLogin = false;
      this.getUserInfo();
    },
    receiveSelectedProject(project) {
      console.log("project = ",project);
      this.selectedProject = project;
    },
    receiveLoadAirline(airline) {
      console.log("receiveLoadAirline");
      console.log("airline = ",airline);
      this.selectedAirline = airline;
      this.isShowProjectAndAirline = false;
      //清除航线
      this.clearAirline();
      //加载航线
      this.loadAirline();
    },
    clearAirline() {
      console.log("clearAirline");
      console.log(this.map);
      this.map.clearMap();
      this.mWaypointsArr.length = 0;
      this.mWaypointsPositionArr.length = 0;
      this.mMarkerList.length = 0;
      this.print(this.mMarkerList);
      this.$message("已全部清除")
    },
    loadAirline() {
      console.log("this.selectedAirline",this.selectedAirline);
      if (this.selectedAirline.waypoints != null) {
        this.mWaypointsArr = JSON.parse(this.selectedAirline.waypoints);
        console.log("this.mWaypointsArr= ",this.mWaypointsArr);
      }
      

      for (let i = 0; i < this.mWaypointsArr.length; i++) {
        const waypoint = this.mWaypointsArr[i];
        var markerTitle = i + 1;
      
        var content = this.getMarkerContent(markerTitle,waypoint.altitude);
        // 创建一个 Marker 实例：
        let position = waypoint.position;
        console.log("position = ",position);
        var marker = new AMap.Marker({
          
            content: content,
            position: new AMap.LngLat(position.longitude ,position.latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            
        });
         // 

        // 将创建的点标记添加到已有的地图实例：
        this.map.add(marker);
        this.mMarkerList.push(marker);

        // console.log("",new AMap.LngLat(lnglat.longitude ,lnglat.latitude))
        this.mWaypointsPositionArr.push(new AMap.LngLat(position.longitude ,position.latitude));
        this.drawPolyline();

      }
      this.goToFirstPoint();
      this.$message({type:'success',message:`加载完成 
      项目${this.selectedProject.projectName}/航线:${this.selectedAirline.airlineName}`});
    },
    goToFirstPoint() {
      //跳往第一个点
      if(this.mWaypointsPositionArr.length > 0) {
        let firstPoint = this.mWaypointsPositionArr[0];
        console.log("firstPoint = ",firstPoint);
        this.map.setCenter( [firstPoint.lng,firstPoint.lat])
      }
    },
    showMissionSetting(){
      this.settingIndex = 0;
    } ,
    showWaypointSetting(){
      this.settingIndex = 1;
    },
    showInterestSetting() {
      this.settingIndex = 2;
    },
    missionAltitudeChanged (percent ) {
      console.log("percent = ",percent);
      this.mAltitude = percent;
    },
    missionSpeedChanged (percent ) {
      console.log("percent = ",percent);
      this.mSpeed = percent;
    },
    waypointAltitudeChanged (percent ) {
      console.log("percent = ",percent);
      this.mWaypointsArr[this.waypointIndex].altitude = percent;
      console.log("this.mWaypointsArr= ",this.mWaypointsArr)

      console.log("this.mMarkerList",this.mMarkerList)
      //修改marker
      let marker = this.mMarkerList[this.waypointIndex];
      // let marker = this.mMarkerList[this.waypointIndex];
      console.log("marker = ",marker);
      var content = this.getMarkerContent(this.waypointIndex + 1,percent);
      
      marker.w.content = content;
      console.log(marker.w)
      console.log(marker.w.position);
      marker.setContent(content)
      
    },
    waypointSpeedChanged (percent ) {
      console.log("percent = ",percent);
      this.mWaypointsArr[this.waypointIndex].speed = percent;
      console.log("this.mWaypointsArr= ",this.mWaypointsArr)
    },
    goToPreviousWaypoint() {
      if (this.waypointIndex >0) {
        this.waypointIndex --;
        let waypoint = this.mWaypointsArr[this.waypointIndex];
         this.map.setCenter([waypoint.position.longitude,waypoint.position.latitude]) 
      }
    },
    goToNextWaypoint() {
      if (this.waypointIndex < this.mWaypointsArr.length -1) {
         this.waypointIndex++;

         let waypoint = this.mWaypointsArr[this.waypointIndex];
         this.map.setCenter([waypoint.position.longitude,waypoint.position.latitude]) 
      }
    },
    
    getUserInfo() {
    
      let url = baseIp + 'user/getUserInfo'
     
      // let param = new FormData();
      // param.append("projectName",this.projectName);
      let config = {
        headers:{
         
        "token":localStorage.getItem('token'),
        "Access-Control-Allow-Origin":'*'
        }
        
      };
      console.log(url);

      this.$ajax.post( url,null,config)
      .then((res)=>{
        console.log(res);
        console.log(res.data); 
        if (res.data.code == 200) {
          let userInfo = res.data.data;
          this.username = userInfo.username;
          //存储token
          localStorage.setItem('userId',res.data.data.id);
          this.isLogin = true;
        }
        else {
          this.isLogin = false;
        }
      
      })
    },
    clearBtnClicked () {
      this.$confirm('确定要删除该航线全部航点吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' // 警告类型（warning/success/info/error）
      }).then(() => {        
        this.clearAirline();
        
      }).catch(() => {

      });

      // var _this = this;
      // $alertBox.alert({
      //   message: "确定要删除该航线全部航点吗?",
      //   showCancel:true,
      //   onConfirm() {
      //     _this.clearAirline();
      //   }
      // })
      
    },
    saveBtnClicked() {
      console.log("this.mWaypointsArr",this.mWaypointsArr);

      if (!this.isLogin) {
        this.loginBtnClicked();
        return;
      }

      console.log("this.selectedProject",this.selectedProject);
      //!this.selectedAirline
      if (!this.selectedProject.projectName) {
        console.log("111");
        this.isShowProjectSave = true;
        // alert("请选择或新建一条航线保存")
        // $alertBox.alert({

        //       message:"请选择或新建一条航线保存"
        //     })
        return;
      }
      this.saveAirline();
    },
    kmlBtnClicked() {
      this.$refs.kmlFileInput.click();
    },
    changes() {
      // console.log(file, 'filefile')
      console.log(this.$refs.kmlFileInput.files[0], 'this.$refs.kmlFileInput')
      // console.log('触发啦啦啦')
      this.analysisKMLFile(this.$refs.kmlFileInput.files[0])
    },
    analysisKMLFile(file) {
      // const reader = new FileReader()
      // console.log(reader.readAsText, 'reader.readAsText')
      let _this = this;
      let reader = new FileReader();
      // console.log(reader.readAsText, 'reader.readAsText')
      reader.readAsText(file, "utf-8");
      // reader.readAsText(file, 'utf-8')
      reader.onload = function(e) {
        const xml = new DOMParser().parseFromString(e.target.result, 'text/xml')
        const geojson = togeojson.kml(xml, {
          style: true
        })
        console.log(geojson, 'geojson')
        console.log("type = ",geojson.features[0].geometry.type)
        _this.loadKMLAirline(geojson)
      }
    },
    loadKMLAirline(geojson) {
      // console.log("this.selectedAirline",this.selectedAirline);
      // if (this.selectedAirline.waypoints != null) {
      //   this.mWaypointsArr = JSON.parse(this.selectedAirline.waypoints);
      //   console.log("this.mWaypointsArr= ",this.mWaypointsArr);
      // }
      this.clearAirline();
      let coordinates = geojson.features[0].geometry.coordinates;
        console.log("coordinates=",coordinates)
      for (let i = 0; i < coordinates.length; i++) {
        const coordinate = coordinates[i];
        console.log("coordinate=",coordinate)

        var markerTitle = i + 1;
      
        var content = this.getMarkerContent(markerTitle,coordinate[2]);
        // 创建一个 Marker 实例：
        let lnglat = {
          lng:coordinate[0],
          lat:coordinate[1]
        };
        console.log("lnglat = ",lnglat);
        var marker = new AMap.Marker({
          
            content: content,
            position: new AMap.LngLat(lnglat.lng ,lnglat.lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            
        });
         // 

        // 将创建的点标记添加到已有的地图实例：
        this.map.add(marker);
        this.mMarkerList.push(marker);

        // console.log("",new AMap.LngLat(lnglat.longitude ,lnglat.latitude))
        this.mWaypointsPositionArr.push(new AMap.LngLat(lnglat.lng ,lnglat.lat));
        let waypoint = {
          altitude:coordinate[2],
          speed:2,
          position: {
            longitude:lnglat.lng,
            latitude:lnglat.lat
          }
        }
        this.mWaypointsArr.push(waypoint);
        console.log("this.mWaypointsArr=",this.mWaypointsArr);
        this.drawPolyline();

      }
      this.goToFirstPoint();
    },
    saveAirline() {
      let url = baseIp + 'airline/updateAirline'
     
      let param = new FormData();
      param.append("airlineId",this.selectedAirline.airlineId);
      param.append("altitude",this.mAltitude);
      param.append("speed",this.mSpeed);
      param.append("waypoints",JSON.stringify(this.mWaypointsArr));
      //  let json = {
      //    airlineId:this.selectedAirline.airlineId,
      //    altitude:this.mAltitude,
      //    speed:this.mSpeed,
      //    waypoints:JSON.stringify(this.mWaypointsArr),
      //  }
      //  let param = json;

      let config = {
        headers:{
          // 'Content-Type':'application/json; charset=utf-8'
        "token":localStorage.getItem('token'),
        "Access-Control-Allow-Origin":'*'
        }
        
      };
      console.log(url);

      this.$ajax.post( url,param,config)
      .then((res)=>{
        console.log(res);
        console.log(res.data); 
    
        if (res.data.code == 200) {
          window.$messageBar.msg("保存成功", 2);
        
        }
        else {
           
            //  $alertBox.alert({

            //   message:res.data.message
            // })
            window.$messageBar.msg("新增成功", 2);
        }
        

      })
    },
    initMap(){
      var map = new AMap.Map('mapContainer', {
                  center: [121.490923, 31.185807],
                  zoom: 14
                });
      map.on('click', this.onMapClicked);
      // map.on('dblclick', showInfoDbClick);
      // map.on('mousemove', showInfoMove);
      this.map = map;
    },
    onMapClicked(e){
      console.log("onMapClicked");
       var text = '您在 [ '+e.lnglat.getLng()+','+e.lnglat.getLat()+' ] 的位置单击了地图！'
       console.log("text=",text);
      
      this.addMarker(e.lnglat);
    },
    
    addMarker(lnglat) {
      console.log("e.lnglat",lnglat);

      var markerTitle = this.mWaypointsArr.length + 1;
      
      var content = this.getMarkerContent(markerTitle,this.mAltitude);
      
      // 创建一个 Marker 实例：
      var marker = new AMap.Marker({
         
          content: content,
          position: new AMap.LngLat(lnglat.lng ,lnglat.lat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          offset: new AMap.Pixel(-15, -50),
          clickable: true,
          extData:this.mWaypointsArr.length
      });
      let _this = this;
      var clickHandle = AMap.event.addListener(marker, 'click', function(e) {
        console.log("e = ",e);
        let index = JSON.parse(JSON.stringify(e.target.getExtData()));
        _this.settingIndex = 1
        _this.waypointIndex = index; 
        let waypoint = _this.mWaypointsArr[_this.waypointIndex];
        _this.map.setCenter([waypoint.position.longitude,waypoint.position.latitude]) 
      });

      // 将创建的点标记添加到已有的地图实例：
      this.map.add(marker);
      this.mMarkerList.push(marker);

       this.mWaypointsPositionArr.push(new AMap.LngLat(lnglat.lng ,lnglat.lat))
       this.drawPolyline();

     
      let waypoint = {
        altitude:this.mAltitude,
        speed:this.mSpeed,
        position: {
          latitude:lnglat.lat,
          longitude:lnglat.lng
        }
      }
      this.mWaypointsArr.push(waypoint);
      console.log("this.mWaypointsArr=",this.mWaypointsArr);
     
    },
    getMarkerContent(markerTitle,altitude) {
     var content =  `<div class="markerContent" style="width:30px;height: auto;">
      <div class="markerHeight" style="
        width:calc(100% - 8px);
        background: black;
        opacity: 0.7;
        color:white;
        border-radius: 2px;
        margin-bottom: 0px;
        border-radius: 4px;
        font-size: 14px;
        padding-left: 4px;
        padding-right: 4px;">${altitude}</div>
        <div style="width:100%;height:40px;position:relative">
        <img class="waypointDirectionIcon" src="${this.waypointDirImg}" style="width:30px;height:36px;top:12px;left:0;position: absolute;" />
       
        <img class="waypointIcon" src="${this.waypointImg}" style="width:36px;height:36px;top:0;left:-3px;position: absolute" />
        <div class="markerTitle" style=" width: 18px;
          height: 18px;
          top: 5px;
          left: 6px;
          position: absolute;
          font-size: 14px;
          background: white;
          color:black;
          border-radius: 50%;
          line-height: 18px;">${markerTitle}</div>
        </div>

    </div>`
      // var content = `<div class="markerContent" style="background:red">
      //                 <div id="markerHeight" style="
      //                 background: black;
      //                 opacity: 0.7;
      //                 color:white;
      //                 border-radius: 2px;
      //                 margin-bottom: 5px;
      //                 border-radius: 4px;
      //                 font-size: 14px;
      //                 padding-left: 4px;
      //                 padding-right: 4px;">${altitude}m</div>
      //                 <div class="markerTitle">${markerTitle}</div>
      //               </div>`;
      return content;
    },
    drawPolyline() {
      console.log("drawPolyline");
      console.log("this.mWaypointsArr",this.mWaypointsArr);
      var polyline = new AMap.Polyline({
          path: this.mWaypointsPositionArr,
          borderWeight: 2, // 线条宽度，默认为 1
          strokeColor: 'green', // 线条颜色
          lineJoin: 'round'
      });
      this.map.add(polyline);
    }
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
.main {
  width:100%;
  height: 100%;
  top:0;
  left:0;
  position: absolute;
}

.header {
  width:100%;
  height: 50px;
  position: relative;
  background: #000000;
  opacity: 0.7;
  color:white;
}
.logoImg {
  width:40px;
  height:40px;
  top:5px;
  left:10px;
  position: absolute;
}
.title {
  width: 300px;
  height: 100%;
  left:10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.registerBtn {
   width:80px;
  height: 100%;
  top:0;
  right:90px;
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loginBtn {
  width:80px;
  height: 100%;
  top:0;
  right:10px;
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.userBox {
  width:80px;
  height: 100%;
  top:0;
  right:10px;
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.userMenu {
  width:100px;
  height: auto;
  top:50px;
  right:10px;
  position:absolute;
  background: rgba(0, 0, 0, 0.8);
  z-index:99;
}
.userMenuItem {
  width:100%;
  height: 30px;
  color:white;
  cursor: pointer;
}

.body {
  width:100%;
  height: calc(100% - 50px - 40px);
  position: relative;
}

.leftMenuBox {
  width:auto;
  height: 40px;
  left:10px;
  top:110px;
  position: relative;
  background: transparent;
  border-radius: 4px;
  color:white;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.leftMenuBtn {
  width:40px;
  height: 40px;
  left:10px;
  top:110px;
  position: relative;
  background: #000;
  border-radius: 4px;
  opacity: 0.7;
  color:white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.airlineInfoBox {
  width:auto;
  min-width: 120px;
  max-width: 400px;
  height: auto;
  top:10px;
  left:10px;
  position: absolute;
  
  border-radius: 4px;
  background: #000;
  opacity: 0.5;
  color:white;
  display: flex;

}
.airlineTitle {
  padding-left: 10px;
  height: 30px;
}
 .airlineName {
   height: 30px;
}
.fileBtn {
  width:40px;
  height:40px;
  left:10px;
  top:60px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}
         
.settingBox {
  width:300px;
  height: auto; 
  top: 10px;
  right: 10px;
  position: absolute;
  background: black;
  opacity: 0.7;
}
.settingHeader {
  width:100%;
  height: 40px;
  position: relative;
  display: flex;
  border-bottom: 1px solid #cccccc;
}
.settingHeaderItem {
  flex:1 0 0;
  color:white;
  line-height: 40px;
  cursor: pointer;
}

.settingContent {
   width:100%;
  height: 300px;
  position: relative;
}

.missionSettingBox {
  width:100%;
  height: 100%;
  position: relative;
}

.missionSettingItem {
  width:calc(100% - 20px);
  padding:10px;
}

.missionSettingItemTitle {
  width:100%;
  color:white;
  display: flex;
  align-items: center;
}

.missionSettingItemTitleName {
  width:auto;
  margin-right: 10px;
  /* color:white;
  display: flex; */
}

.settingFooter {
   width:100%;
  height: 40px;
  position: relative;
  display: flex;
}      

.waypointOperationBtn {
  flex:1 0 0;
  color:white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.previousImg {
  width:20px;
  height: 20px;
}
.nextImg {
  width:20px;
  height: 20px;
}
.normalImg {
   width:20px;
  height: 20px;
}

#mapContainer {
  width:100%;
  height: 100%;
}
.markerContent {
  background:red;width:30px;height: auto;
}
.markerTitle {
  width: 18px;
  height: 18px;
  top: 5px;
  left: 5px;
  position: absolute;
  font-size: 14px;
  background: white;
  color:black;
  border-radius: 50%;
  line-height: 18px;
}
.waypointIcon {
  width:36px;height:36px;top:0;left:-3px;position: absolute
}
.waypointDirectionIcon {
  width:30px;height:36px;top:12px;left:0;position: absolute;
}

.markerHeight {
  width:calc(100% - 8px);
  background: black;
  opacity: 0.7;
  color:white;
  border-radius: 2px;
  margin-bottom: 0px;
  border-radius: 4px;
  font-size: 14px;
  padding-left: 4px;
  padding-right: 4px;
}

.footer {
  bottom:0;
  width: 100%;
  height: 40px;
  background-color: #000;
  color: white;
  line-height: 40px;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue